import { render, staticRenderFns } from "./CommunityCatalog.vue?vue&type=template&id=20e6e96c&scoped=true&"
import script from "./CommunityCatalog.vue?vue&type=script&lang=js&"
export * from "./CommunityCatalog.vue?vue&type=script&lang=js&"
import style0 from "./CommunityCatalog.vue?vue&type=style&index=0&id=20e6e96c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e6e96c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCardTitle,VIcon})
